import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import LatestArticles from './components/LatestArticles';
import HotTopics from './components/HotTopics';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar transparent />
      <main>
        <HeroSection />
        <CategoryGrid />
        <LatestArticles />
        <HotTopics />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}